module.exports = __webpack_public_path__ + "assets/img/swiper-3-9.a6841278.png";